<template>
  <div>
    <h1>{{ $t("workflow.processField.processFilled") }}</h1>
    <b-row>
      <b-col cols="0" class="ml-3">
        <b-button size="sm" @click="showModal()">
          {{ $t("geral.createNew") }}
        </b-button>
      </b-col>
      <b-col cols="0" class="ml-2">
        <router-link
          :to="`/workflow/filled/import/${processName}/${processId}`"
        >
          <b-button size="sm">
            {{ $t("geral.import") }}
          </b-button>
        </router-link>
        <!-- <b-button size="sm" @click="showImportModal()">
          {{ $t("geral.import") }}
        </b-button> -->
      </b-col>
      <b-col cols="0" class="ml-2">
        <b-button size="sm" @click="layoutModal()">
          {{ $t("geral.importLayout") }}
        </b-button>
      </b-col>
      <b-col cols="0" class="ml-2">
        <b-button size="sm" @click="getAllFields()">
          {{ $t("workflow.processes.editColumns") }}
        </b-button>
      </b-col>
      <b-col cols="0" class="ml-2">
        <b-button size="sm" @click="openExportModal()">Exportar CSV</b-button>
      </b-col>
    </b-row>
    <!-- {{ permissions }} -->
    <!-- {{ processName }} -->

    <div v-if="isLoadingFilters && isLoadingFields">
      <div class="text-center my-2">
        <b-spinner class="align-middle"></b-spinner>
        <strong>{{ $t("geral.loadingData") }}</strong>
      </div>
    </div>
    <div v-else>
      <b-table
        ref="table"
        class="nowrapActions kanban-board-card"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :filter="tableFilters"
        :filter-debounce="500"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>{{ $t("geral.loadingData") }}</strong>
            <div>{{ loadingError }}</div>
          </div>
        </template>
        <template #head()="scope">
          <div v-if="scope.field.key == 'actions'">
            <b-form-group
              :label="$t('geral.saveFilters')"
              label-for="saveFilter"
              class="labelSaveFilter"
            >
              <b-form-checkbox
                class="checkboxSaveFilter"
                id="saveFilter"
                v-model="filterApplied.saveFilter"
              ></b-form-checkbox>
            </b-form-group>
            <b-button size="sm" @click="cleanFilters()">
              {{ $t("geral.cleanFilters") }}
            </b-button>
          </div>
          <div v-else>
            <workflow-filter
              class="filters"
              :labelName="scope.field.label"
              :fieldType="scope.field.type"
              :fieldId="scope.field.fieldId"
              :filter="getFilter(scope.field)"
              :dateOpt.sync="
                fields[getFieldIndex(scope.field.label)].optionFilterDate
              "
              :filterApplied="filterApplied"
            ></workflow-filter>
          </div>
          <div class="mt-1">
            {{ scope.label }}
          </div>
        </template>

        <template v-slot:cell(viagens)="data">
          <!-- {{data.item}} -->
          <a
            href="#"
            v-if="$store.getters.darkmode"
            class="link"
            @click="downloadTripPlan(data.item)"
          >
            {{ data.item.viagem }}
            <i class="tim-icons icon-attach-87"></i>
          </a>
          <a
            href="#"
            v-if="!$store.getters.darkmode"
            class="link2"
            @click="downloadTripPlan(data.item)"
          >
            {{ data.item.viagem }}
            <i class="tim-icons icon-attach-87"></i>
          </a>
        </template>
        <template v-slot:cell(actions)="data">
          <workflow-filled-actions
            :id="parseInt(data.item.Id)"
            :stageId="data.item.StatusId"
            :model="data.item"
            :permission="permissions"
            @refreshData="refreshTable"
          />
        </template>
        <template v-slot:cell()="data">
          <workflow-filled-list-cell :field="data.field" :item="data.item" />
        </template>
      </b-table>
      <table-pagination-props
        :currentPage.sync="tableCurrentPage"
        :pageOptions.sync="tablePageOptions"
        :perPage.sync="tablePerPage"
        :rowCount.sync="tableRowCount"
      >
      </table-pagination-props>
    </div>

    <!-- filtros -->
    <workflow-all-fields-modal
      ref="allFields"
      :processId="processId"
      :selectedFields="selectedFields"
      :selected.sync="selected"
      @refreshFilter="refreshFilter"
    ></workflow-all-fields-modal>

    <!-- Histórico -->
    <process-story-modal ref="workflowStory"></process-story-modal>

    <!-- criar novo processo -->
    <workflow-fill-modal
      ref="fillModal"
      :id="processId"
      @refreshData="refreshTable"
    >
    </workflow-fill-modal>

    <!-- importar processo -->
    <workflow-import-modal
      ref="importModal"
      :processId="processId"
      @refreshData="refreshTable"
    >
    </workflow-import-modal>

    <!-- layout de importação -->
    <workflow-import-layout-modal ref="layoutImport" :processId="processId">
    </workflow-import-layout-modal>

    <!-- exportar csv -->
    <workflow-export-csv-modal
      ref="ExportCsvModal"
      :processId="processId"
      :tableFilters="tableFilters"
      :fields="fields"
    ></workflow-export-csv-modal>

    <!-- <pre class="language-json"><code>Filters: {{ tableFilters  }}</code></pre> -->
    <!-- <pre class="language-json"><code>FiltersApplied: {{ filterApplied  }}</code></pre> -->
  </div>
</template>
<script>
export default {
  name: "WorkflowFilled",
  props: {
    processId: String,
    processName: String,
  },
  components: {
    TablePaginationProps: () =>
      import("@/components_rms/base/TablePaginationProps.vue"),
    WorkflowFilledActions: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowFilledActions.vue"
      ),
    ProcessStoryModal: () =>
      import("@/components_rms/workflow/Process/ProcessStoryModal.vue"),
    WorkflowAllFieldsModal: () =>
      import(
        "@/components_rms/workflow/WorkflowFilled/WorkflowAllFieldsModal.vue"
      ),
    WorkflowFilter: () =>
      import("@/components_rms/workflow/WorkflowFilled/WorkflowFilter.vue"),
    WorkflowFillModal: () =>
      import("@/components_rms/workflow/WorkflowFillModal.vue"),
    WorkflowImportModal: () =>
      import("@/components_rms/workflow/WorkflowImportModal.vue"),
    WorkflowImportLayoutModal: () =>
      import("@/components_rms/workflow/WorkflowImportLayoutModal.vue"),
    "workflow-filled-list-cell": () =>
      import("@/pagesRms/Workflow/WorkflowFilledListCell.vue"),
    WorkflowExportCsvModal: () =>
      import("@/components_rms/workflow/WorkflowExportCsvModal.vue"),
  },
  data() {
    return {
      isBusy: false,
      isLoadingFields: true,
      isLoadingFilters: true,
      tableFilters: {
        fields: [],
      },
      fields: [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "checklist-filled-table-col-buttons",
          thStyle: "min-width: 250px !important",
        },
      ],
      values: [],
      allFields: [],
      selectedFields: [],
      selected: [],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150, 200, 300, 400, 500, 600, 700, 800, 900, 1000],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
      commentId: 0,
      commentStageId: 0,
      nextStatusId: 0,
      latitude: 0.0,
      longitude: 0.0,
      optionsActive: [
        { value: "", text: "Todos" },
        { value: "1", text: "Sim" },
        { value: "0", text: "Não" },
      ],
      permissions: {
        administrador: false,
        gestor: false,
        simpleOperator: false,
      },
      filterApplied: {
        pageUrl: "",
        saveFilter: true,
        appliedFilters: "",
        filterDateApplied: [],
      },
      tableFilterApplied: {},
      loadingError: "",
    };
  },
  created() {
    this.getFilters();
    this.getFields();
    this.getPermissions();
  },
  computed: {},
  methods: {
    openExportModal() {
      this.$refs.ExportCsvModal.openModal();
    },
    getFieldIndex(label) {
      for (let i = 0; i < this.fields.length; i++) {
        let field = this.fields[i];
        if (field.label == label) {
          return i;
        }
      }
      return 0;
    },
    getFilter(field) {
      for (let filter of this.tableFilters.fields) {
        if (filter.label == field.label) {
          return filter;
        }
      }
      return null;
    },
    getDateOption(field) {
      return field.optionFilterDate;
    },
    onChangeDateOption(newValue, field) {
      console.log("onChangeDateOption");
      console.log(newValue);
      console.log(field.optionFilterDate);
      console.log(field.label);
      field.optionFilterDate = newValue;
      this.$forceUpdate();
    },
    refreshView() {
      console.log("refreshView");
      // this.fields.forEach((field) => {
      //   if (field.label == "DATA INÍCIO") {
      //     field.optionFilterDate = 2;
      //   }
      // });
      this.$refs.table.refresh();
    },
    openStoryModal(id) {
      this.$refs.workflowStory.openModal(id);
    },
    showModal() {
      this.$refs.fillModal.show();
    },
    showImportModal() {
      this.$refs.importModal.show();
    },
    layoutModal() {
      this.$refs.layoutImport.show();
    },
    getAllFields() {
      this.$refs.allFields.show();
    },
    refreshTable() {
      console.log("RefreshTable");
      this.$refs.table.refresh();
    },
    myProvider(ctx, callback) {
      if (this.isLoadingFilters) {
        this.isBusy = false;
        this.tableRowCount = 0;
        return [];
      }

      let fieldsFilter = [];
      ctx.filter.fields.forEach((field) => {
        fieldsFilter.push({ label: field.label, value: field.value ?? "" });
      });

      this.isBusy = true;
      let items = [];
      let apiParam = {
        currentPage: ctx.currentPage,
        perPage: (ctx.perPage = ctx.perPage),
        fields: fieldsFilter,
      };
      this.$apiWorkflow
        .post("/processFilled/getAllCustom/" + this.processId, apiParam)
        .then((response) => {
          // console.log(response.data.items);
          items = response.data.items;
          let r = [];
          items.forEach((item) => {
            r.push(item.labels);
          });
          this.tableRowCount = response.data.totalItems;
          this.saveFilterApplied();
          callback(r);
        })
        .catch((error) => {
          console.log(error);
          console.log(error.response);
          console.log(error.response.data);
          this.loadingError = "Erro: " + error.response.data.detail;
          this.$forceUpdate();
          console.log(this.loadingError);
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              this.alert.error = `${error.response.status} - ${error.response.statusText}\n${error.response.data}`;
              this.$refs.danger.show();
            } else {
              this.alert.error = error.message;
              this.$refs.danger.show();
            }
          }
        });
    },
    getFields() {
      // console.log("getFields");
      this.$apiWorkflow
        .get("/field/getSelected/" + this.processId)
        .then((response) => {
          if (response.data != "") {
            this.selectedFields = response.data;
          }
          this.isLoadingFields = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.isLoadingFields = false;
          this.$forceUpdate();
        });
    },
    async saveFilterApplied() {
      this.filterApplied.pageUrl = window.location.href;
      let stringFilter = JSON.stringify(this.tableFilters);
      if (this.filterApplied.saveFilter == true) {
        this.filterApplied.appliedFilters = stringFilter;
        this.$apiWorkflow
          .post("/fitlerApplied/saveFilters/", this.filterApplied)
          .then((response) => {
            let model = JSON.parse(response.data.appliedFilters);
            this.tableFilters = model;
            this.filterApplied.appliedFilters = response.data.appliedFilters;
          });
      }
    },
    getFilters() {
      this.filterApplied.pageUrl = window.location.href;
      this.$apiWorkflow
        .post("/customFilter/tableFilter/" + this.processId, this.filterApplied)
        .then((response) => {
          if (response.data != null) {
            let fields = response.data.fields;
            let filters = response.data.filters;
            // Estilo ThStyle
            fields.forEach((f) => {
              f.thStyle = "vertical-align: bottom !important;";
              this.fields.push(f);
            });
            // Estilo TdClass
            fields.forEach((x) => {
              if (x.type == 1) {
                x.tdClass = "type-logic";
              }
              if (x.type == 2) {
                x.tdClass = "type-date";
              }
              if (x.type == 3) {
                x.tdClass = "type-hour";
              }
              if (x.type == 4) {
                x.tdClass = "type-decimal";
              }
              if (x.type == 5) {
                x.tdClass = "type-int";
              }
              if (x.type == 6) {
                x.tdClass = "type-text";
              }
              if (x.type == 7) {
                x.tdClass = "type-list";
              }
              if (x.type == 10) {
                x.tdClass = "type-aattachment";
              }
              if (x.type == 9000) {
                x.tdClass = "type-integration-script";
              }
            });
            filters.forEach((label) => {
              this.tableFilters.fields.push(label);
            });
          }
          // this.fields.push(active);
          this.isLoadingFilters = false;
          this.$forceUpdate();
        })
        .catch((error) => {
          console.log(error);
          if (error.response) {
            if (error.response.data) {
              console.log(error.response.data.errors);
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
          }
          this.isLoadingFilters = false;
          this.$forceUpdate();
        });
    },
    cleanFilters() {
      this.tableFilters.fields.forEach((field) => {
        field.value = "";
      });
      this.saveFilterApplied();
    },
    downloadTripPlan(data) {
      this.$apiWorkflow
        .request({
          url: "/path/print/" + data.Id,
          method: "POST",
          data: data,
          responseType: "arraybuffer", //important
        })
        .then((response) => {
          const downloadUrl = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers["content-type"],
            })
          );
          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", response.headers["filename"]);
          document.body.appendChild(link);
          link.click();
          link.remove();
        });
    },
    getPermissions() {
      this.$apiWorkflow
        .get("/customFilter/GetPerimissions/" + this.processId)
        .then((response) => {
          this.permissions = response.data;
        });
    },
    refreshFilter() {
      this.$refs.table.refresh();
      // console.log("this.selectedFields");
      // console.log(this.selected);
      this.tableFilters.fields = [];
      this.fields = [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
      ];
      this.getFilters();
      this.getFields();
    },
  },
  watch: {
    processId() {
      console.log("Entrou");
      // console.log(this.tableFilters);
      this.tableFilters.fields = [];
      this.fields = [
        {
          key: "actions",
          sortable: false,
          label: "",
          tdClass: "nowrapActions",
        },
      ];
      this.getFilters();
      this.getFields();
    },
  },
};
</script>
<style scoped>
.table-width {
  min-width: 600px;
}

.link {
  text-decoration: underline;
  color: white !important;
}

.link2 {
  text-decoration: underline;
}

.checkboxSaveFilter {
  margin-left: 105px;
  margin-top: -28px;
}

.checklist-filled-table-col-buttons {
  width: 130px;
}

.vertical-align {
  vertical-align: bottom !important;
}
</style>